import * as React from "react";
import { H1, H2 } from "./";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

const header: React.CSSProperties = {
  color: greys[5],
  marginTop: 30,
};

const subHeader: React.CSSProperties = {
  fontWeight: 600,
  fontSize: 20,
  color: greys[4],
};

interface IProps {
  id?: string;
  children?: React.ReactNode;
}

export const MarketingHeader = ({ id, children }: IProps) => (
  <H1 id={id} style={header}>
    {children}
  </H1>
);

export const MarketingSubHeader = ({ id, children }: IProps) => (
  <H2 id={id} style={subHeader}>
    {children}
  </H2>
);
